module.exports = __webpack_public_path__ + "static/img/app.839cc75.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/app.png
// module id = 1069
// module chunks = 1